/* eslint-disable */
import { Route, BrowserRouter as BaseRoutes, Switch } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import React from 'react';
import Home from './pages/Home';

const Routes = observer(() => {
    return (
        <BaseRoutes>
            <Switch>
                <Route path="/" exact component={Home} />
                <Route component={Home} />
            </Switch>
        </BaseRoutes>
    );
});

export default Routes;
